export default "__VITE_PUBLIC_ASSET__9c492114__"